$(document).ready(function() {
    if ($(".container-documentacion-client")[0]) {
        let file;
        let nameFil;

        $("#document").on("change", function(e) {
            $(".preloaderDoc")[0].parentNode.classList.add("displayPro");

            file = this.files[0];
            activeModals_(e);
        });

        function activeModals_(e) {
            const ext = [
                "xls",
                "xlsx",
                "pdf",
                "jpeg",
                "jpg",
                "png",
                "doc",
                "docx",
                "odf",
                "rtf"
            ];
            // Name of file and placeholder
            const datos = $(e.target).parents(".container-contact-client");
            const modals = $(".modalDocument").modal();
            instance = M.Modal.getInstance(modals[0]);
            instance.options.dismissible = false;
            console.log(instance);
            instance.options.onCloseEnd=function () {
                $(".preloaderDoc")[0].parentNode.classList.add("displayPro");
            }
            const elModal = instance.$el[0];
            const nameExt = file.name.split(".");
            const extFt = ext.indexOf(nameExt[nameExt.length - 1]);
            console.log(nameExt[nameExt.length - 1]);
            if (extFt == -1) {
                swal({
                    text: "Archivo no valido",
                    icon: imageURL,
                    button: "OK!"
                });
            } else {
                nameFil = file.name.split(".");
                nameFil.pop();
                $("#nameFile").val(nameFil.join(".").toString());
                instance.open();
            }
        }

        let dropArea = document.querySelector(".content_fileIcon");

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false);
        });

        ["dragenter", "dragover"].forEach(eventName => {
            dropArea.addEventListener(eventName, add_class_dra, false);
        });
        ["dragleave", "drop"].forEach(eventName => {
            dropArea.addEventListener(eventName, remove_class_dra, false);
        });

        function add_class_dra(e) {
            dropArea.classList.add("content_Drop");
        }

        function remove_class_dra(e) {
            dropArea.classList.remove("content_Drop");
        }

        dropArea.addEventListener("drop", handleDrop, false);

        function handleDrop(e) {
            let dt = e.dataTransfer;
            let files = dt.files;
            file = files[0];
            activeModals_(e);
        }

        $("#modalDocument > div.modal-footer > div > a").mouseup(function() {
            $("#modalDocument > div.modal-footer > div > a").attr(
                "disabled",
                ""
            );

            var formData = new FormData();
            formData.append("idViewsCliPros", $("#idViewsCliPros").val());
            formData.append("type_user", $("#type_user").val());
            formData.append("iduser", $("#iduser").val());
            formData.append("nameFile", $("#nameFile").val());
            formData.append("document", file);

            $.ajax({
                url: https + "UploadDocument",
                method: "POST",
                data: formData,
                contentType: false,
                cache: false,
                processData: false,
                beforeSend: function() {
                    $(".preloaderDoc")[0].parentNode.classList.remove(
                        "displayPro"
                    );
                },
                success: function(data) {
                    if ($.trim(data[0]) == "1") {
                        console.log(data);
                        if(data[1]!='invalid'){
                            new itemFileDocument(data[1]);
                            instance.close();
                            $("#document").val("");
                            $(
                                "#modalDocument > div.modal-footer > div > a"
                            )[0].removeAttribute("disabled");
                        }else{
                            swal({
                                text: "Error al subir este archivo, probablemente excedió el peso permitido, comprima el archivo e inténtelo de nuevo.",
                                icon: imageURL,
                                button: "OK!"
                            });
                            instance.close();
                            $("#document").val("");
                            $(
                                "#modalDocument > div.modal-footer > div > a"
                            )[0].removeAttribute("disabled");
                            $(".preloaderDoc")[0].parentNode.classList.add("displayPro");   
                        }

                        
                    } else if ($.trim(data) == "2") {
                        swal({
                            text: "No tiene los permisos necesarios",
                            icon: imageURL,
                            button: "OK!"
                        });
                    } else {
                        swal({
                            text: "Error, hubo problemas",
                            icon: imageURL,
                            button: "OK!"
                        });
                    }
                }
            });
        });

        $("#modalDocument > div.modal-header > div > a").click(function() {
            $("#document").val("");
            $(".preloaderDoc")[0].parentNode.classList.add("displayPro");
        });

        /*   <div class="col s12 itemFile">
        <!-- Cuerpo Contactos-->
        <div class="col s4 nameFile center-align"><p>Documento 1</p> </div>
        <div class="col s4 dataFile center-align"><p>2019-08-30</p></div>
        <div class="col s4 iconFile center-align"><p><i class="flaticon-pdf-file-format-symbol"></i></p> </div>
    </div> */

        function itemFileDocument(obj) {
            const extType = [
                "flaticon-xls-file-format-symbol", //xls
                "flaticon-xlsx-file-format-extension", //xlsx
                "flaticon-pdf-file-format-symbol", //pdf
                "flaticon-jpg-file-format-variant", //jpeg
                "flaticon-jpg-file-format-variant", //jpg
                "flaticon-png-file-format-symbol", //png
                "flaticon-doc-file-format", //doc
                "flaticon-docx-file-format-symbol", //docx
                "flaticon-odf-file-format", //odf
                "flaticon-rtf-file-symbol" //rtf
            ];
            const ext = [
                "xls",
                "xlsx",
                "pdf",
                "jpeg",
                "jpg",
                "png",
                "doc",
                "docx",
                "odf",
                "rtf"
            ];

            const fileDocument = $(".fileDocument");

            const itemFile = $("<div>")
                .addClass("col s12 itemFile")
                .appendTo(fileDocument);

            const nameFile = $("<div>")
                .addClass("col s4 nameFile center-align")
                .appendTo(itemFile);
            $("<p>")
                .text(obj.name_file)
                .appendTo(nameFile);

            const dataFile = $("<div>")
                .addClass("col s4 dataFile center-align")
                .appendTo(itemFile);
            console.log(obj.updated_at);
            $("<p>")
                .text(obj.updated_at.split(" ")[0])
                .appendTo(dataFile);

            const iconFile = $("<div>")
                .addClass("col s4 iconFile center-align")
                .appendTo(itemFile);
            const pIcon = $("<p>").appendTo(iconFile);
            const type = obj.path_file.split(".");
            const aDow = $("<a>")
                .attr("href", https + obj.path_file)
                .appendTo(pIcon);
            const iSet = $("<i>")
                .attr("id", "file_" + obj.id)
                .addClass(extType[ext.indexOf(type[type.length - 1])])
                .appendTo(aDow);
                console.log();
            if (
                type[type.length - 1] == "pdf" ||
                type[type.length - 1] == "png" ||
                type[type.length - 1] == "jpg" ||
                type[type.length - 1] == "jpeg"
            ) {
                aDow.attr("target", "_blank");
            } else {
                aDow.attr("download", "");
            }

            /*         iSet.click(function () {
            console.log(this.id);
            const idFile=this.id.split("_")[1];
            $.ajax({
                url: https + "UploadDocumentSet",
                method: "POST",
                data: {
                    idViewsCliPros: $("#idViewsCliPros").val(),
                    type_user: $("#type_user").val(),
                    iduser: $("#iduser").val(),
                    id_file: idFile
                },
                beforeSend: function() {},
                success: function(data) {
                    if ($.trim(data[0]) == "1") {
                        console.log(data);
                        
                    } else if ($.trim(data) == "2") {
                        swal({
                            text: "No tiene los permisos necesarios",
                            icon: imageURL,
                            button: "OK!"
                        });
                    } else {
                        swal({
                            text: "Error, hubo problemas",
                            icon: imageURL,
                            button: "OK!"
                        });
                    }
                }
            });

        }) */
        }

        itemFileDocument.prototype.add = function() {};

        $.ajax({
            url: https + "UploadDocumentGet",
            method: "POST",
            data: {
                idViewsCliPros: $("#idViewsCliPros").val(),
                type_user: $("#type_user").val(),
                iduser: $("#iduser").val()
            },
            beforeSend: function() {},
            success: function(data) {
                if ($.trim(data[0]) == "1") {
                    console.log(data);
                    for (const key in data[1]) {
                        if (data[1].hasOwnProperty(key)) {
                            const element = data[1][key];
                            new itemFileDocument(element);
                        }
                    }

                } else if ($.trim(data) == "2") {
                    swal({
                        text: "No tiene los permisos necesarios",
                        icon: imageURL,
                        button: "OK!"
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!"
                    });
                }
            }
        });
    }
});
